import React from 'react';
import { WMDivider, WMSkeleton } from '@walkme/wm-ui';
import Grid from '@material-ui/core/Grid/Grid';

import BellIllustration from '../../../assets/icons/bell-illustration.svg';

import classes from './AppSkeleton.module.scss';
import { Locations } from '../../models/locations';
import { useLocation } from 'react-router-dom';

const FakeHeader = ({ button }: { button: boolean }) => (
    <div className={classes.fakeHeader}>
        <WMSkeleton height={20} width={250} />
        {button && <WMSkeleton height={30} width={150} />}
    </div>
);

const FakeTabs = ({ count }: { count: number }) => (
    <div className={classes.fakeTabsBar}>
        <div className={classes.tabs}>
            {Array(count)
                .fill(null)
                .map((_, index) => (
                    <WMSkeleton key={index} height={14} width={60} />
                ))}
        </div>
    </div>
);

const FakeTable = () => (
    <div className={classes.fakeTableContainer}>
        <WMSkeleton className={classes.fakeDefaultTable} variant="text" animation="pulse" />
    </div>
);

const FakeAnalytics = () => (
    <div className={classes.analytics}>
        <div className={classes.analyticsHeader}>
            <WMSkeleton className={classes.title} height={16} variant="text" animation="wave" width={220} />
            <WMSkeleton className={classes.subtitle} height={14} variant="text" animation="wave" width={90} />
        </div>

        <WMSkeleton className={classes.bigCube} variant="rect" animation="pulse" />

        <WMSkeleton className={classes.bigCube} variant="rect" animation="pulse" />

        <WMSkeleton className={classes.bigCube} variant="rect" animation="pulse" />
    </div>
);

const AppSkeleton = () => {
    const { pathname } = useLocation()

    return (
        <Grid item xs={12} className={classes.root} data-testid="app-skeleton">
            {pathname === Locations.Edit ? (
                <div className={classes.editRoot}>
                    <div className={classes.editHeader}>
                        <div className={classes.leftSide}>
                            <WMSkeleton height={20} width={20} variant={'circle'} />

                            <WMDivider className={classes.divider} />

                            <WMSkeleton height={20} width={250} variant={'text'} />
                        </div>
                    </div>

                    <div className={classes.editContent}>
                        <div className={classes.skeletonHero}>
                            <div className={classes.bell}>
                                <img src={BellIllustration} alt="Loading" />
                            </div>
                            <WMSkeleton className={classes.item} height={12} variant="text" animation="wave" width={187} />
                            <WMSkeleton className={classes.item} height={12} variant="text" width={274} animation="wave" />
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <Grid container className={classes.pageContent}>
                        <FakeHeader button={pathname !== Locations.Audiences} />

                        {pathname !== Locations.UsersPermissions && <FakeTabs count={pathname === Locations.Audiences ? 2 : 5} />}

                        <FakeTable />
                    </Grid>

                    {pathname !== Locations.UsersPermissions && pathname !== Locations.Audiences && <FakeAnalytics />}
                </>
            )}
        </Grid>
    );
};

export default AppSkeleton;
